import { render, staticRenderFns } from "./SmsPartnerTariffZone.vue?vue&type=template&id=5774b608&"
import script from "./SmsPartnerTariffZone.vue?vue&type=script&lang=ts&"
export * from "./SmsPartnerTariffZone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports